/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Spinner } from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';

import DivisionDetail from '../components/DivisionDetail';
import * as pActions from '../actions/permit';
import * as types from '../constants';
import * as utils from '../utils/stringUtils';

const permitId = types.BOUNDARY_WATERS_PERMIT_ID;

export class DivisionDetailPage extends Component {
    static propTypes = {
        router: COMPAT_ROUTER_PROP_TYPES,
        dispatch: PropTypes.func,
        permit: PropTypes.shape({
            divisions: PropTypes.shape({}),
            id: PropTypes.string,
            name: PropTypes.string,
            recareas: PropTypes.arrayOf(PropTypes.string),
        }),
        permitType: PropTypes.string,
        permitDate: PropTypes.string,
    };

    static defaultProps = {
        permit: {
            divisions: [],
            id: '',
            name: '',
        },
    };

    componentDidMount() {
        this.props.dispatch(pActions.fetchPermit(permitId)).then(() => {
            // fetch recArea for breadcrumbs
            let recId = 0;

            if (this.props.permit.recareas[0]) {
                recId = this.props.permit.recareas[0];
            }

            this.props.dispatch(pActions.fetchRecarea(recId));
        });
    }

    render() {
        if (
            !this.props.permit ||
            permitId !== this.props.permit.id ||
            !(
                this.props.permit.divisions &&
                Object.keys(this.props.permit.divisions).includes(
                    this.props.router.params.divisionId
                )
            )
        ) {
            return (
                <div className="permit-loading-wrapper">
                    <Spinner />
                </div>
            );
        }

        const divisionContent =
            this.props.permit.divisions[this.props.router.params.divisionId];
        const division = {
            ...divisionContent,
            description: utils.removeHTMLTags(divisionContent?.description),
        };

        return (
            <div className="boundarywaters">
                <DivisionDetail
                    division={division}
                    permitDate={this.props.permitDate}
                    permitId={this.props.permit.id}
                    permitName={this.props.permit.name}
                    permitType={this.props.permitType}
                />
            </div>
        );
    }
}

export default withCompatRouter(
    connect((state) => {
        return {
            error: state.boundarywaters.permit.error,
            permit: state.boundarywaters.permit.result,
            permitDate: state.boundarywaters.permitDate,
            permitType: state.boundarywaters.permitType,
        };
    })(DivisionDetailPage)
);

// cSpell:ignore recareas, boundarywaters, Recarea
